import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { getTheme, applyTheme } from "@/lib/theme";

export const ThemeToggle = ({ className = "", showLabel = false }) => {
  const [theme, setTheme] = useState(getTheme);

  useEffect(() => { applyTheme(theme); }, [theme]);

  const next = theme === "dark" ? "light" : "dark";
  return (
    <button type="button" data-testid="theme-toggle"
            onClick={() => setTheme(next)}
            title={`Switch to ${next} mode`}
            className={`inline-flex items-center gap-2 transition-colors ${className}`}>
      {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
      {showLabel && <span>{theme === "dark" ? "Light mode" : "Dark mode"}</span>}
    </button>
  );
};

export default ThemeToggle;
